let AttachmentUsages;

(function (AttachmentUsages) {
  AttachmentUsages["SIGNATURE"] = "http://adlnet.gov/expapi/attachments/signature";
  AttachmentUsages["CERTIFICATE_OF_COMPLETION"] = "http://id.tincanapi.com/attachment/certificate-of-completion";
  AttachmentUsages["CONTRACT"] = "http://id.tincanapi.com/attachment/contract";
  AttachmentUsages["SUPPORTING_MEDIA"] = "http://id.tincanapi.com/attachment/supporting_media";
})(AttachmentUsages || (AttachmentUsages = {}));

let Resources;

(function (Resources) {
  Resources["ABOUT"] = "about";
  Resources["AGENTS"] = "agents";
  Resources["STATE"] = "activities/state";
  Resources["ACTIVITY_PROFILE"] = "activities/profile";
  Resources["AGENT_PROFILE"] = "agents/profile";
  Resources["STATEMENT"] = "statements";
})(Resources || (Resources = {}));

class Verbs {}
Verbs.INITIALIZED = {
  id: "http://adlnet.gov/expapi/verbs/initialized",
  display: {
    "en-US": "initialized"
  }
};
Verbs.TERMINATED = {
  id: "http://adlnet.gov/expapi/verbs/terminated",
  display: {
    "en-US": "terminated"
  }
};
Verbs.SUSPENDED = {
  id: "http://adlnet.gov/expapi/verbs/suspended",
  display: {
    "en-US": "suspended"
  }
};
Verbs.RESUMED = {
  id: "http://adlnet.gov/expapi/verbs/resumed",
  display: {
    "en-US": "resumed"
  }
};
Verbs.PASSED = {
  id: "http://adlnet.gov/expapi/verbs/passed",
  display: {
    "en-US": "passed"
  }
};
Verbs.FAILED = {
  id: "http://adlnet.gov/expapi/verbs/failed",
  display: {
    "en-US": "failed"
  }
};
Verbs.SCORED = {
  id: "http://adlnet.gov/expapi/verbs/scored",
  display: {
    "en-US": "scored"
  }
};
Verbs.COMPLETED = {
  id: "http://adlnet.gov/expapi/verbs/completed",
  display: {
    "en-US": "completed"
  }
};
Verbs.RESPONDED = {
  id: "http://adlnet.gov/expapi/verbs/responded",
  display: {
    "en-US": "responded"
  }
};
Verbs.COMMENTED = {
  id: "http://adlnet.gov/expapi/verbs/commented",
  display: {
    "en-US": "commented"
  }
};
Verbs.VOIDED = {
  id: "http://adlnet.gov/expapi/verbs/voided",
  display: {
    "en-US": "voided"
  }
};
Verbs.PROGRESSED = {
  id: "http://adlnet.gov/expapi/verbs/progressed",
  display: {
    "en-US": "progressed"
  }
};
Verbs.ANSWERED = {
  id: "http://adlnet.gov/expapi/verbs/answered",
  display: {
    "en-US": "answered"
  }
};

const crlf = "\r\n";
function parseMultiPart(data) {
  const boundary = data.trim().split(crlf)[0].trim();
  const parts = data.split(boundary).map(part => part.trim()).filter(part => part !== "" && part !== "--");
  const parsedParts = [];

  for (let partIndex = 0; partIndex < parts.length; partIndex++) {
    const headers = {};
    const items = parts[partIndex].split(crlf);

    for (let j = 0; j < items.length - 2; j++) {
      const header = items[j].split(":");
      headers[header[0]] = header[1];
    }

    let data = items[items.length - 1];

    if (headers["Content-Type"].indexOf("application/json") > -1) {
      data = JSON.parse(data);
    }

    parsedParts.push(data);
  }

  return parsedParts;
}
function createMultiPart(statement, attachments) {
  const blobParts = [];
  const boundary = (Math.random() + " ").substring(2, 10) + (Math.random() + " ").substring(2, 10);
  const header = {
    "Content-Type": `multipart/mixed; boundary=${boundary}`
  }; // Add statement to blob

  const statementHeader = [`--${boundary}`, "Content-Type: application/json", "Content-Disposition: form-data; name=\"statement\"", "", JSON.stringify(statement)].join(crlf) + crlf;
  blobParts.push(statementHeader); // Add attachments to blob

  attachments.forEach((attachmentArrayBuffer, index) => {
    const attachmentMeta = statement.attachments[index];
    const attachmentHeader = [`--${boundary}`, `Content-Type: ${attachmentMeta.contentType}`, "Content-Transfer-Encoding: binary", `X-Experience-API-Hash: ${attachmentMeta.sha2}`].join(crlf) + crlf + crlf;
    blobParts.push(attachmentHeader);
    blobParts.push(attachmentArrayBuffer);
  });
  blobParts.push(`${crlf}--${boundary}--${crlf}`);
  return {
    header: header,
    blob: new Blob(blobParts)
  };
}

function getSearchQueryParamsAsObject(str) {
  const obj = {};
  const queryString = str.split("?")[1] || null;
  if (!queryString) return obj;
  const items = queryString.split("&");
  items.forEach(n => {
    const item = n.split("=");
    const decodedItem = decodeURIComponent(item[1]);

    try {
      obj[item[0]] = JSON.parse(decodedItem);
    } catch {
      obj[item[0]] = decodedItem;
    }
  });
  return obj;
}

const secondsInMinute = 60;
const secondsInHour = secondsInMinute * 60;
const secondsInDay = secondsInHour * 24;
function calculateISO8601Duration(startDate, endDate) {
  const differenceSeconds = (endDate.getTime() - startDate.getTime()) / 1000;
  const days = Math.floor(differenceSeconds / secondsInDay);
  const hoursSeconds = differenceSeconds % secondsInDay;
  const hours = Math.floor(hoursSeconds / secondsInHour);
  const minuteSeconds = hoursSeconds % secondsInHour;
  const minutes = Math.floor(minuteSeconds / secondsInMinute);
  const remainingSeconds = minuteSeconds % secondsInMinute;
  const seconds = Math.ceil(remainingSeconds);
  return `P${days ? days + "D" : ""}T${hours ? hours + "H" : ""}${minutes ? minutes + "M" : ""}${seconds ? seconds + "S" : ""}`;
}

class XAPI {
  constructor(endpoint, auth) {
    this.endpoint = endpoint;
    this.headers = {
      "X-Experience-API-Version": "1.0.3",
      "Content-Type": "application/json",
      // No Authorization Process and Requirements -  https://github.com/adlnet/xAPI-Spec/blob/master/xAPI-Communication.md#no-authorization-process-and-requirements
      Authorization: auth ? auth : `Basic ${btoa(":")}`
    };
  } // About Resource


  getAbout() {
    return this.request(Resources.ABOUT);
  } // Agents Resource


  getAgent(agent) {
    return this.request(Resources.AGENTS, {
      agent: JSON.stringify(agent)
    });
  } // Statement Resource


  getStatement(query) {
    return this.request(Resources.STATEMENT, query);
  }

  getVoidedStatement(query) {
    return this.request(Resources.STATEMENT, query);
  }

  getStatements(query) {
    return this.request(Resources.STATEMENT, query);
  }

  getMoreStatements(more) {
    const params = getSearchQueryParamsAsObject(more);
    return this.request(Resources.STATEMENT, params);
  }

  sendStatement(statement, attachments) {
    if (attachments === null || attachments === void 0 ? void 0 : attachments.length) {
      const multiPart = createMultiPart(statement, attachments);
      return this.requestXMLHTTPRequest(Resources.STATEMENT, {}, {
        method: "POST",
        headers: multiPart.header,
        body: multiPart.blob
      });
    } else {
      return this.request(Resources.STATEMENT, {}, {
        method: "POST",
        body: JSON.stringify(statement)
      });
    }
  }

  voidStatement(actor, statementId) {
    const voidStatement = {
      actor,
      verb: Verbs.VOIDED,
      object: {
        objectType: "StatementRef",
        id: statementId
      }
    };
    return this.request(Resources.STATEMENT, {}, {
      method: "POST",
      body: JSON.stringify(voidStatement)
    });
  } // State Resource


  createState(agent, activityId, stateId, state, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      stateId: stateId,
      ...(registration ? {
        registration
      } : {})
    }, {
      method: "POST",
      body: JSON.stringify(state)
    });
  }

  setState(agent, activityId, stateId, state, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      stateId: stateId,
      ...(registration ? {
        registration
      } : {})
    }, {
      method: "PUT",
      body: JSON.stringify(state)
    });
  }

  getStates(agent, activityId, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      ...(registration ? {
        registration
      } : {})
    });
  }

  getState(agent, activityId, stateId, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      stateId: stateId,
      ...(registration ? {
        registration
      } : {})
    });
  }

  deleteState(agent, activityId, stateId, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      stateId: stateId,
      ...(registration ? {
        registration
      } : {})
    }, {
      method: "DELETE"
    });
  }

  deleteStates(agent, activityId, registration) {
    return this.request(Resources.STATE, {
      agent: JSON.stringify(agent),
      activityId: activityId,
      ...(registration ? {
        registration
      } : {})
    }, {
      method: "DELETE"
    });
  } // Activity Profile Resource


  createActivityProfile(activityId, profileId, profile) {
    return this.request(Resources.ACTIVITY_PROFILE, {
      activityId: activityId,
      profileId: profileId
    }, {
      method: "POST",
      body: JSON.stringify(profile)
    });
  }

  setActivityProfile(activityId, profileId, profile) {
    return this.request(Resources.ACTIVITY_PROFILE, {
      activityId: activityId,
      profileId: profileId
    }, {
      method: "PUT",
      body: JSON.stringify(profile)
    });
  }

  getActivityProfiles(activityId) {
    return this.request(Resources.ACTIVITY_PROFILE, {
      activityId: activityId
    });
  }

  getActivityProfile(activityId, profileId) {
    return this.request(Resources.ACTIVITY_PROFILE, {
      activityId: activityId,
      profileId: profileId
    });
  }

  deleteActivityProfile(activityId, profileId) {
    return this.request(Resources.ACTIVITY_PROFILE, {
      activityId: activityId,
      profileId: profileId
    }, {
      method: "DELETE"
    });
  } // Agent Profile Resource


  createAgentProfile(agent, profileId, profile) {
    return this.request(Resources.AGENT_PROFILE, {
      agent: JSON.stringify(agent),
      profileId: profileId
    }, {
      method: "POST",
      body: JSON.stringify(profile)
    });
  }

  setAgentProfile(agent, profileId, profile) {
    return this.request(Resources.AGENT_PROFILE, {
      agent: JSON.stringify(agent),
      profileId: profileId
    }, {
      method: "PUT",
      body: JSON.stringify(profile)
    });
  }

  getAgentProfiles(agent) {
    return this.request(Resources.AGENT_PROFILE, {
      agent: JSON.stringify(agent)
    });
  }

  getAgentProfile(agent, profileId) {
    return this.request(Resources.AGENT_PROFILE, {
      agent: JSON.stringify(agent),
      profileId: profileId
    });
  }

  deleteAgentProfile(agent, profileId) {
    return this.request(Resources.AGENT_PROFILE, {
      agent: JSON.stringify(agent),
      profileId: profileId
    }, {
      method: "DELETE"
    });
  }

  request(resource, params = {}, init) {
    const queryString = Object.keys(params).map(key => key + "=" + encodeURIComponent(params[key])).join("&");
    const url = `${this.endpoint}${resource}${queryString ? "?" + queryString : ""}`;
    return fetch(url, {
      headers: this.headers,
      ...init
    }).then(response => {
      if (response.ok) {
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json();
        } else {
          return response.text().then(data => {
            return data.indexOf("--") === 2 ? parseMultiPart(data) : data;
          });
        }
      } else {
        return response.text().then(error => Promise.reject(error));
      }
    });
  }

  requestXMLHTTPRequest(resource, params = {}, initExtras) {
    return new Promise((resolve, reject) => {
      const xmlRequest = new XMLHttpRequest();
      const queryString = Object.keys(params).map(key => key + "=" + encodeURIComponent(params[key])).join("&");
      const url = `${this.endpoint}${resource}${queryString ? "?" + queryString : ""}`;
      xmlRequest.open((initExtras === null || initExtras === void 0 ? void 0 : initExtras.method) || "GET", url, true);
      const headers = { ...this.headers,
        ...(initExtras === null || initExtras === void 0 ? void 0 : initExtras.headers)
      };
      const headerKeys = Object.keys(headers);

      for (let i = 0; i < headerKeys.length; i++) {
        const key = headerKeys[i];
        xmlRequest.setRequestHeader(key, headers[key]);
      }

      xmlRequest.onloadend = () => {
        if (xmlRequest.status >= 200 && xmlRequest.status < 400) {
          try {
            resolve(JSON.parse(xmlRequest.responseText));
          } catch {
            resolve(xmlRequest.responseText.indexOf("--") === 2 ? parseMultiPart(xmlRequest.responseText) : xmlRequest.responseText);
          }
        } else {
          reject(xmlRequest.response);
        }
      };

      xmlRequest.onerror = () => {
        reject(xmlRequest.response);
      };

      xmlRequest.send(initExtras === null || initExtras === void 0 ? void 0 : initExtras.body);
    });
  }

}
XAPI.AttachmentUsages = AttachmentUsages;
XAPI.Verbs = Verbs;
XAPI.calculateISO8601Duration = calculateISO8601Duration;
XAPI.getSearchQueryParamsAsObject = getSearchQueryParamsAsObject;

export default XAPI;
